import { Button } from "@mui/material";
import { CompareArrowsOutlined as ReplaceIcon } from "@mui/icons-material";
import type { ProductResponse } from "../../admin/products/productsApi";
import { ProductMapDialog } from "../../admin/products/map/ProductMapDialog";

export function AlternativeProductFromMapDialog(props: {
  products: ProductResponse[];
  open: boolean;
  onClose: () => void;
  onReplace?: (product: ProductResponse, date?: string) => void;
  date?: string;
}) {
  return (
    <ProductMapDialog open={props.open} onClose={props.onClose} products={props.products}>
      {props.onReplace && <ReplaceButton onClick={props.onReplace} />}
    </ProductMapDialog>
  );
}

function ReplaceButton(props: {
  product?: ProductResponse;
  date?: string;
  onClick(product: ProductResponse, date: string): void;
}) {
  return (
    <Button startIcon={<ReplaceIcon />} onClick={() => props.onClick(props.product!, props.date!)}>
      Zastąp
    </Button>
  );
}
